<!-- Moved to <body> on init. Same shell as the progress and confirmation modals: header strip,
     16px body, then the action. Opened by the leave guard, never by a link. No close cross: the
     member answers to go on (see the component for the failure exit). -->
<div class="modal fade" bsModal #modal="bs-modal" [config]="modalConfig" (onShown)="onShown()" (onHidden)="onHidden()" tabindex="-1" role="dialog" aria-modal="true" [attr.aria-labelledby]="titleId">
    <div class="modal-dialog modal-dialog-centered exit-question__frame">
        <div class="modal-content exit-question__panel" #panel>
            <header class="exit-question__head">
                <div class="exit-question__heading">
                    <h4 class="exit-question__title" [id]="titleId">{{ sent ? 'Thank you.' : title }}</h4>
                    <p class="exit-question__prompt" *ngIf="prompt && !sent">{{ prompt }}</p>
                </div>
            </header>

            <ng-container *ngIf="!sent; else thanks">
                <div class="exit-question__body">
                    <div class="exit-question__options" role="radiogroup" [attr.aria-labelledby]="titleId" *ngIf="reasons.length">
                        <button type="button" class="exit-question__option" role="radio" *ngFor="let reason of reasons; let i = index"
                            [class.exit-question__option--active]="selectedReasonId === reason.id"
                            [attr.aria-checked]="selectedReasonId === reason.id"
                            [attr.tabindex]="chipTabIndex(reason, i)"
                            (click)="toggleReason(reason)" (keydown)="onChipKeydown($event, i)">
                            <span class="exit-question__option-text">{{ reason.label }}</span>
                            <i class="bi bi-check2 exit-question__option-check" aria-hidden="true"></i>
                        </button>
                    </div>

                    <label class="exit-question__label" [for]="textId">Anything else? What would make this easier? (optional)</label>
                    <textarea class="form-control exit-question__text" [id]="textId" rows="3" [attr.maxlength]="maxLength"
                        [attr.aria-describedby]="counterId" [attr.placeholder]="placeholder || null" [value]="text"
                        (input)="onText($event)"></textarea>
                    <p class="exit-question__counter" [id]="counterId" [class.exit-question__counter--near]="text.length >= warnFrom">
                        {{ text.length }} / {{ maxLength }}
                    </p>

                    <button type="button" class="exit-question__action exit-question__action--single" [disabled]="!canSend" (click)="send()">
                        {{ sending ? 'Sending...' : 'Send.' }}
                    </button>
                    <!-- Only after a failed send, so an error never traps the member here. -->
                    <button type="button" class="exit-question__leave" *ngIf="sendFailed && !sending" (click)="dismiss()">
                        Leave without sending.
                    </button>
                </div>
            </ng-container>

            <ng-template #thanks>
                <div class="exit-question__body" role="status">
                    <div class="exit-question__success">
                        <img src="assets/images/check.png" alt="" aria-hidden="true">
                        <h4>The team will see this.</h4>
                    </div>
                    <p class="exit-question__success-note">You can come back and pick up where you left off anytime.</p>
                    <button type="button" class="exit-question__action exit-question__action--single" (click)="dismiss()">Okay.</button>
                </div>
            </ng-template>
        </div>
    </div>
</div>
